angular.module('impactx.tender').controller('MostUsedLotCtrl', MostUsedLotCtrl);

MostUsedLotCtrl.$inject = ['$scope', 'dataGen', 'ToolbarService'];

function MostUsedLotCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    $scope.search = function() {
        dataGen.getData($scope, {}, '/lot/mostused');
    };

    $scope.search();

    $scope.hasLots = function() {
        return $scope.data && $scope.data.numOfLots && $scope.data.numOfLots > 0
    }
}